import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.PDN,
  displayName: "Pdn",
  isCustomerFacing: true,
};

export default entitlement;
